import { composeIO } from 'react-compose-io'
import { ciclosIO } from './Ciclos.IO'
import { CiclosView } from './Ciclos.View'

export const Ciclos = composeIO(CiclosView, ciclosIO)
